import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Resources from "./pages/resources";
import Events from "./pages/events";
import Projects from "./pages/projects";
import Teams from "./pages/team";
import ContactUsPage from "./pages/ContactUsPage";
import About from "./pages/about";
import Services from "./pages/services";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/events" element={<Events />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/team" element={<Teams />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="*" element={<h1> PAGE NOT FOUND</h1>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
